var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKoala2Icon = function SvgKoala2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 51"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M36.48 1.594a6.14 6.14 0 0 0-2.974.765 6.3 6.3 0 0 0-2.256 2.118 10.67 10.67 0 0 0-7.28-2.883 10.67 10.67 0 0 0-7.278 2.883 6.3 6.3 0 0 0-2.375-2.18 6.15 6.15 0 0 0-6.172.27A6.3 6.3 0 0 0 5.96 4.944a6.48 6.48 0 0 0 .14 6.3 6.3 6.3 0 0 0 2.288 2.274 6.16 6.16 0 0 0 3.091.825 6 6 0 0 0 1.694-.268 11.17 11.17 0 0 0 3.566 7.016 10.76 10.76 0 0 0 7.24 2.815c2.67 0 5.247-1.002 7.24-2.815a11.17 11.17 0 0 0 3.566-7.016c.55.17 1.12.26 1.694.268a6.2 6.2 0 0 0 4.42-1.867 6.44 6.44 0 0 0 1.83-4.508A6.44 6.44 0 0 0 40.9 3.46a6.2 6.2 0 0 0-4.42-1.867"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29.584 22.313h11.402c.229 0 .455.051.663.15.207.1.39.244.537.424a1.61 1.61 0 0 1 .337 1.308c-.417 2.357-1.777 6.086-6.042 6.086h-9.375a29.2 29.2 0 0 1-1.806 8.69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.598 24.225c-2.742 3.496-6.369 9.07-6.369 14.025 0 7.969 4.687 11.156 9.375 11.156h15.07c.625 0 1.236-.19 1.753-.548a3.18 3.18 0 0 0 1.15-1.455l2.34-5.965"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.167 39.844c2.433-2.482 7.708-2.066 12.143.501M23.979 12.75v3.188"
  })));
};
export default SvgKoala2Icon;